<template>
  <div class="panel granary-panel">
    <div class="chart-box">
      <div class="tab-box flex">
        <div
          v-for="(item, index) in typeList"
          :key="index"
          class="tab-item"
          :class="{ active: active === index }"
          @click="changeType(index)"
        >
          <span>{{ item }}</span>
        </div>
      </div>
      <div ref="chart" class="chart"></div>
    </div>
  </div>
</template>

<script>
import { loadChart } from "./charts/scData";
import { findQueryList } from "@/api/granary";
import { timerMixin } from "@/util/mixin/timerMixin";
export default {
  mixins: [timerMixin],
  data() {
    return {
      typeList: ["谷物", "豆类", "薯类", "经济作物", "其他作物"],
      active: 0
    };
  },
  mounted() {
    this.getData();
    this.startTimer();
  },
  methods: {
    runs() {
      let len = this.typeList.length;
      let active = Number(this.active);
      if (active < len - 1) {
        active++;
      } else {
        active = 0;
      }
      this.changeType(active, false);
    },
    changeType(index, clearT = true) {
      this.active = index;
      this.getData();
      if (clearT) {
        this.startTimer();
      }
    },
    getData() {
      this.chart = this.$echarts.init(this.$refs.chart);
      findQueryList({
        code: "nzw_zzt",
        series: this.typeList[this.active]
      }).then(res => {
        const data = res.data;
        if (data instanceof Array) {
          let slist = [];
          let line = [];
          data.forEach(ele => {
            slist.push(ele.dq);
            line.push(Number(ele.area));
          });
          loadChart(this.chart, slist, line, this.typeList[this.active]);
        }
      });
      // const slist = ["茂南区", "电白区", "信宜市", "高州市", "化州市"];
      // // const resultArr = ["谷物", "豆类", "薯类", "经济作物", "其他作物"];
      // const line = [
      //   [336993, 665911, 690113, 837463, 775983],
      //   [899, 15155, 10359, 8596, 15452],
      //   [18143, 62022, 125007, 46052, 97235],
      //   [83286, 256872, 202828, 155625, 363793],
      //   [184444, 508996, 300623, 387572, 437868]
      // ];
      // loadChart(
      //   this.chart,
      //   slist,
      //   line[this.active],
      //   this.typeList[this.active]
      // );
      // const data = {
      //   year: this.year === "全部" ? "" : this.year,
      //   city: this.city === "广东省" ? "" : this.city,
      //   type: this.flm === "全部" ? "" : this.flm
      // };

      // getTop10(data).then(res => {
      //   // console.log("top10", res);
      //   if (res) {
      //     let slist = [];
      //     let line = [];
      //     res.forEach(ele => {
      //       slist.push(ele.name);
      //       line.push(Number(ele.num));
      //     });
      //     loadChart(this.chart, slist, line);
      //     window.addEventListener("resize", () => {
      //       setTimeout(() => {
      //         this.chart.resize();
      //       }, 300);
      //     });
      //   }
      // });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.panel
  height 100%
  width 100%
  .chart-box
    width 100%
    height 100%
    position relative
    .tab-box
      position absolute
      top 10px
      right 4%
      z-index 999
      .tab-item
        color #fff
        font-size 10px
        padding-left 13px
        margin-right 20px
        position relative
        cursor pointer
        &:before
          content ' '
          // width 6px
          // height 6px
          width 12px
          height 12px
          border-radius 50%
          background #fff
          position absolute
          left 0
          top 50%
          transform translateY(-50%)
      .active
        color #0e9cff
        &:before
          background #0e9cff
    .chart
        height 100%
        width 100%
</style>
